import _ from 'lodash-es';
import Defaults from '~/scripts/constants/defaults';
import Card from '~/scripts/services/model/card';

export default class InputCardController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {any} $scope
	 * @param {import('angular').translate.ITranslateService} $translate
	 */
	constructor(
		$element,
		$scope,
		$translate,
	) {
		this.$element = $element;
		this.$scope = $scope;
		this.$translate = $translate;

		this.cardModelName = {
			from: 'from',
			to: 'to',
		};

		/** @type {boolean} */
		this.disabled = false;

		/** @type {string | undefined} */
		this.from = undefined;

		/** @type {string | any} */
		this.model = undefined;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {any} */
		this.options = {};

		/** @type {boolean} */
		this.required = false;

		/** @type {string | undefined} */
		this.to = undefined;

		/** @type {Card} */
		this.value = new Card(0, 0);
	}

	/**
	 * @param {KeyboardEvent} event
	 */
	checkKeyTo(event) {
		if (event.key === 'n') {
			event.preventDefault();
			this.to = 'N';
			this.update();
		}
	}

	update() {
		let out;

		if (this.from === undefined || !/\d/.test(this.from)) {
			this.from = '0';
		}

		if (this.to === undefined || !/\d|'N'/.test(this.to)) {
			this.to = 'N';
		}

		this.value = new Card(this.from, this.to);
		if (this.options.type === 'string') {
			out = `${this.value}`;
		}
		else if (this.options.type === 'object') {
			if (this.to === `${Defaults.KCARDN}`) {
				this.to = 'N';
			}
			if (typeof this.model !== 'object') {
				this.model = {};
			}
			out = _.merge(this.model, {
				[this.cardModelName.from]: this.value.from,
				[this.cardModelName.to]:   this.value.to,
			});
		}

		this.ngModelCtrl?.$setViewValue(out);
	}

	$doCheck() {
		// if (typeof this.from !== 'undefined' && typeof this.to !== 'undefined') {
		// 	// @ts-ignore
		// 	if (this.from === 'n') {
		// 		this.from = 'N';
		// 	}
		// 	// @ts-ignore
		// 	if (this.to === 'n') {
		// 		this.to = 'N';
		// 	}
		// 	this.ngModelCtrl?.$setViewValue({
		// 		from: this.from === 'N'
		// 			? Defaults.KCARDN : (typeof this.from === 'string' ? Number.parseInt(this.from, 10) : this.from),
		// 		to: this.to === 'N'
		// 			? Defaults.KCARDN : (typeof this.to === 'string' ? Number.parseInt(this.to, 10) : this.to),
		// 	});
		// }
		// else {
		// 	this.ngModelCtrl?.$setViewValue(undefined);
		// }
	}

	$onInit() {
		this.options = _.merge({ type: 'string' }, this.options || {});

		// format text going to user (model to view)
		this.ngModelCtrl?.$formatters.push(value => {
			if (typeof value === 'string') {
				const r = /^(\d+)-(\d+|N)$/.exec(value);
				this.value = r ? new Card(value) : new Card(0, Defaults.KCARDN);
			}
			else if (typeof value === 'object') {
				if ('card_from' in value && 'card_to' in value) {
					this.cardModelName.from = 'card_from';
					this.cardModelName.to = 'card_to';
					this.value = new Card(value[this.cardModelName.from], value[this.cardModelName.to]);
				}
				else {
					this.value = new Card(value.from, value.to);
				}
				// this.value.from =
				// this.value.from = Number.parseInt(`${value[this.cardModelName.from]}`, 10);
				// this.value.to = Number.parseInt(value[this.cardModelName.to], 10) === Defaults.KCARDN
				// 	? 'N' : `${value[this.cardModelName.to]}`;
			}

			this.from = this.value.getString('from');
			this.to = this.value.getString('to');

			return this.options.type === 'object' ? this.value : String(this.value);
		});

		this.$scope.$watch('$ctrl.options.type', (/** @type {string} */ newType, /** @type {string} */ oldType) => {
			if (newType !== oldType) {
				this.update();
			}
		});

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.required = (modelValue, viewValue) => {
				let valid = !this.required;
				if (
					this.required && viewValue
					&& viewValue.from !== undefined
					&& viewValue.to !== undefined
				) {
					valid = false;
				}
				this.customError = !valid && !this.ngModelCtrl?.$pristine
					? this.$translate.instant('error.kform.required') : undefined;

				return valid;
			};

			this.ngModelCtrl.$validators.check = () => {
				const valid = this.value.check();

				this.customError = !valid && !this.ngModelCtrl?.$pristine
					? this.$translate.instant('error.invalid-card') : undefined;

				return valid;
			};
		}
	}
}
